<template>
  <div class="home">
    <section class="home-section-1">
      <HomeHero/>
      <HomeTransitionHero class="s-hide-sm"/>
      <HomeFeature
        id="home-products"
        :title="$t('home-page.feature-drag&drop.title')"
        :subtitle="$t('home-page.feature-drag&drop.subtitle')"
        :text="$t('home-page.feature-drag&drop.text')"

        imageSource="Home_DragDrop_Asset_SVG.svg"
        lottiePath="LottieDragAndDrop"
        videoPlaceholder="Home_DragDrop_Video_PH_SVG.svg"
      />



      <div class="home-section-1-bg">
        <HomeFeature
          isFlipped

          :title="$t('home-page.feature-automate.title')"
          :subtitle="$t('home-page.feature-automate.subtitle')"
          :text="$t('home-page.feature-automate.text')"

          imageSource="Home_Automate_Asset_SVG.svg"
          lottiePath="LottieAuto"
          videoSource=""
          videoPlaceholder="Home_Automate_Video_PH_SVG.svg"
        />

        <HomeFeature
          :title="$t('home-page.feature-search.title')"
          :subtitle="$t('home-page.feature-search.subtitle')"
          :text="$t('home-page.feature-search.text')"

          imageSource="Home_Search_Asset_SVG.svg"
          lottiePath="LottieSearch"
          videoPlaceholder="Home_Search_Video_PH_SVG.svg"
        />
      </div>
    </section>
    <section class="home-testimonials-bg">
      <HomeTestimonials2/>
    </section>

    <HomeTransition1 class="s-hide-sm"/>

    <section class="home-promotion">
      <HomePromotion class="home-promotion-bg"/>
    </section>

    <section class="home-section-2 bg-shade" id="home-section-2">
      <div class="home-section-2-bg ">
        <HomePlansContainer class="home-section-plans"/>
      </div>
    </section>

    <section class="home-subscribe">
      <HomeSubscribeForm/>

    </section>

    <section class="home-faq">
      <div class="home-plans-questions">
        <h2>{{ $t('home-page.questions-title') }}</h2>
        <div class="home-plans-cta">

          <s-button class="link-blue button-secondary" btn-link="https://www.seedr.cc/faq/">{{ $t('actions.faq') }}</s-button>
          <s-button class="link-blue button-secondary" btn-link="https://help.seedr.cc/hc/en-us/requests/new">{{ $t('actions.contact-us') }}</s-button>

        </div>
      </div>
    </section>
  </div>
</template>

<script>

import HomeHero from '@/components/HomeHero.vue'
import HomeFeature from '@/components/HomeFeature.vue'
import HomeTransition1 from '@/components/HomeTransition1.vue'
import HomeTransitionHero from '@/components/HomeTransitionHero.vue'
import HomePromotion from '@/components/HomePromotion.vue'
import HomeTestimonials2 from '@/components/HomeTestimonials2.vue'
import HomePlansContainer from '@/components/HomePlansContainer.vue'
import HomeSubscribeForm from '@/components/HomeSubscribeForm.vue'
import SButton from "@/components/SButton.vue";

export default {
  name: 'home',
  components: {
    SButton,
    HomeHero,
    HomeFeature,
    HomeTransition1,
    HomeTransitionHero,
    HomePromotion,
    HomeTestimonials2,
    HomePlansContainer,
    HomeSubscribeForm
  }
}
</script>
